var map = {
	"./glas_1.png": "968c",
	"./glas_2.png": "21de",
	"./glas_3.png": "7da5",
	"./glas_4.png": "7d57",
	"./glas_5.png": "e449",
	"./glas_empty.png": "3580"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d2d7";